/**
 * Use on scroll to highlight menu items #menu-header
 */
jQuery( $ => {
	// close menu in mobile when selecting a scroll item
	$( '.nav-menu-mobile a' ).on( 'click', function() {
		$( '#mobile-button' ).trigger( 'click' );
	} );
	// Activate a scroll on load
	window.scroll( {
		top: 1,
	} );
	// Get all sections that have an ID defined
	const sections = document.querySelectorAll( 'div[id]' );

	// Add an event listener listening for scroll
	window.addEventListener( 'scroll', menuHighlight );
	//window.onscroll = menuHighlight();

	function menuHighlight() {
		// Get current scroll position
		const scrollY = window.pageYOffset;
		// Now we loop through sections to get height, top and ID values for each
		sections.forEach( current => {
			const sectionHeight = current.offsetHeight;
			const sectionTop = current.offsetTop - 150;
			const sectionId = current.getAttribute( 'id' );

			// Add and remove active classes after offset check
			if (
				scrollY > sectionTop &&
      scrollY <= sectionTop + sectionHeight
			) {
				$( '#menu-header a[href*="/#' + sectionId + '"]' ).parent().addClass( 'current-menu-item' );
			} else {
				$( '#menu-header a[href*="/#' + sectionId + '"]' ).parent().removeClass( 'current-menu-item' );
			}
		} );
	}
} );
